import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface DonationStats {
  totalDonated: number;
  totalDonatedInEuros: number;
  myDonations: number;
  myDonationsInEuros: number;
  donorCount: number;
  regionalHubId: number;
  regionalHubName: string;
}

export interface EVHub {
  id: number;
  name: string;
  description?: string;
  avatar?: string;
  city: string;
  totalDonations: number;
  totalDonationsInEuros: number;
}

export interface CreateDonationRequest {
  businessHubId: number;
  amount: number;
  message?: string;
  isAnonymous: boolean;
}

export interface CreateDonationResponse {
  success: boolean;
  donation?: any;
  message?: string;
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class DonationService {
  private apiUrl = `${environment.apiUrl}/business/donations`;

  constructor(private http: HttpClient) {}

  getRegionalStats(): Observable<{ success: boolean; stats: DonationStats }> {
    return this.http.get<{ success: boolean; stats: DonationStats }>(
      `${this.apiUrl}/regional-stats`
    );
  }

  getEVHubs(): Observable<{ success: boolean; hubs: EVHub[] }> {
    return this.http.get<{ success: boolean; hubs: EVHub[] }>(
      `${this.apiUrl}/ev-hubs`
    );
  }

  createDonation(request: CreateDonationRequest): Observable<CreateDonationResponse> {
    return this.http.post<CreateDonationResponse>(
      `${this.apiUrl}/create`,
      request
    );
  }
}